/**
 * Requirement scripts
 *
 * @copyright 2018 Linguistica 360
 */

import { Script, injector } from '../shared/injector.js';

import Modernizr from 'modernizr';

injector.injectClass(class extends Script {
    onLoad() {
        const problem = this.nMeetRequirements();
        if (problem) window.location.replace(`/not-supported/${problem}`);
    }

    nMeetRequirements() {
        if (!Modernizr.flexbox || !Modernizr.flexwrap || Modernizr.flexboxtweener) {
            return 'flexbox';
        }

        if (!Modernizr.sessionstorage) {
            return 'sessionstorage';
        }

        if (!Modernizr.localstorage) {
            return 'localstorage';
        }

        return false;
    }
});
